import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-g2-review-dialog',
  templateUrl: './g2-review-dialog.component.html',
  styleUrls: ['./g2-review-dialog.component.scss'],
})
export class G2ReviewDialogComponent implements OnInit {
  safeUrl: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<G2ReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string },
  ) {}

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }

  close(): void {
    this.dialogRef.close();
  }
}
